import React from "react";
import {
  AddressContainer,
  ContactDetailsContainer,
  CorporateOffice,
  CorporateOfficeContainer,
  GeneralContainer,
  HeadingText,
  HRDepartement,
  RegisterOfficeText,
  RegistredOfficeContainer,
  SalesContainer,
  SubHeading,
  ContactText,
} from "./style";

const Address = () => {
  return (
    <AddressContainer>
      <RegistredOfficeContainer>
        <HeadingText>Registered Office</HeadingText>
        <RegisterOfficeText>
          BELLAD CHAMBERS P.B Road, Vidyanagar Hubli, Karnataka 580031, India
        </RegisterOfficeText>
      </RegistredOfficeContainer>
      <CorporateOfficeContainer>
        <HeadingText>Corporate Office</HeadingText>
        <CorporateOffice>
          2nd Floor, Leeman's Complex, 30/1, Cunningham Rd, Vasanth Nagar,
          Bengaluru, Karnataka 560052
        </CorporateOffice>
      </CorporateOfficeContainer>
      <ContactDetailsContainer>
        <HeadingText>Contact Details</HeadingText>
        <HRDepartement>
          <SubHeading>HR Department</SubHeading>
          <ContactText>hr@beltech.ai</ContactText>
          <ContactText>+919901628881</ContactText>
        </HRDepartement>
        <SalesContainer>
          <SubHeading>Sales:</SubHeading>
          <ContactText>sales@beltech.ai</ContactText>
          <ContactText>+917022295390</ContactText>
        </SalesContainer>
        <GeneralContainer>
          <SubHeading>General:</SubHeading>
          <ContactText>office@beltech.ai</ContactText>
          <ContactText>+919845102222</ContactText>
        </GeneralContainer>
      </ContactDetailsContainer>
    </AddressContainer>
  );
};

export default Address;
